import { graphql } from '../../../gql';

export const UPDATE_POST_STORY_ANALYSIS_MUTATION = graphql(`
  mutation updatePostStoryAnalysis($postId: ID!, $analysis: JSON) {
    updatePostStoryAnalysis(postId: $postId, analysis: $analysis) {
      id
      status
      savedSinceModeration
      analyzedSinceLastSave
      updatedAt
    }
  }
`);
